import type { LaunchTransactionActionArgs, TransactionActionMode } from './proposalTypes';

// Shared, capability-agnostic validation/normalization used by the framework itself (id
// dedup/trim, single-vs-batch inference). Feature-specific validation (e.g. rejecting a no-op
// payee rename) lives in each feature's own validators.ts instead - see the "Result validator"
// plugin-contract section in docs/features/transaction-actions/README.md.
//
// Phase-1 support gating is NOT here: it's read directly off each capability's own
// `supportedInPhase1` field via the capability registry (capabilities.ts), so a capability
// declares its own support in one place instead of also needing a second, hand-maintained list.

export { validateRenamePayeeProposals } from './features/rename-payee';

export const normalizeTransactionActionIds = (transactionIds: string[]): string[] =>
  Array.from(
    transactionIds.reduce<Set<string>>((acc, transactionId) => {
      const normalizedId = transactionId.trim();
      if (normalizedId) acc.add(normalizedId);
      return acc;
    }, new Set<string>()),
  );

export const resolveTransactionActionMode = (
  requestedMode: LaunchTransactionActionArgs['mode'],
  transactionIds: string[],
): TransactionActionMode => {
  if (requestedMode) {
    return requestedMode;
  }

  return transactionIds.length <= 1 ? 'single' : 'batch';
};
